import { panel, refinementList } from 'instantsearch.js/es/widgets'
import {
  isCollapsed, panelClasses, templates, wrapHeading,
} from './panels'
import { refinementClasses, refinementItem } from './menuRefinement'

export const panelRefinement = (container, attribute, label, options = {}) => {
  if (!attribute) {
    console.error('Attribute is required for refinement widget')
    return null
  }
  const shouldSortNumerically = options.sort === 'number' || false

  return panel({
    templates: {
      header: wrapHeading(label),
      collapseButtonText: templates.collapseButtonText,
    },
    hidden(options) {
      return options.results.nbHits === 0
    },
    collapsed: ({ state }) =>
      isCollapsed(container),
    cssClasses: panelClasses,
  })(refinementList)({
    container,
    sortBy: shouldSortNumerically ? (a, b) => {
      const numA = parseFloat(a.escapedValue)
      const numB = parseFloat(b.escapedValue)
      if (Number.isNaN(numA) && Number.isNaN(numB)) {
        return 0
      }
      if (Number.isNaN(numA)) {
        return -1
      }
      if (Number.isNaN(numB)) {
        return 1
      }
      return numA - numB
    } : ['name:asc'],
    limit: 15,
    showMore: true,
    showMoreLimit: 30,
    attribute,
    cssClasses: refinementClasses,
    templates: {
      item: refinementItem,
    },
    transformItems: (items) => items,
    ...options,
  })
}
